export default {
  newDesign: true,
  parameters: {
    landing_id: "LatFwdTn",
    segment: 44,
  },
  title:
    "Responde estas 5 preguntas y recibe una clase gratuita para tu hijo/a | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde estas 5 preguntas y recibe una clase gratuita para tu hijo/a",
    subtitle:
      "Tu hijo dominará el dibujo digital en una tableta y explorará otras habilidades creativas como la animación, la ilustración, el modelado en 3D y el diseño.",
    image: {
      url: "/welcome/latam_fwd_tab_new_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_fwd_tab_new_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Presiona para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo pasa frente a la computadora o tablet sea más productivo?",
      answers: [
        "🔥 ¡Si!",
        "🤗 No. Lo hace solo para divertirse y eso está bien",
      ],
    },
    2: {
      question:
        "¿Qué habilidades tiene tu hijo con la computadora o laptop?",
      answers: [
        "👍 Aún no tiene experiencia, necesita aprender lo básico",
        "🙌 Nivel básico — usa PowerPoint y apps básicas",
        "💻 Nivel intermedio — usuario confiado, quiere explorar más",
        "🕹 Principalmente usa computadora o tableta para jugar",
      ],
    },
    3: {
      question:
        "¿Tienen una tablet en casa?",
      answers: [
        "📱 Sí, tenemos un iPad",
        "🤖 Sí, tenemos una tablet Android",
        "🛒 Planeamos comprar una tablet",
        "🚫 No planeamos comprar una tablet"
      ],
    },
    4: {
      question:
        "¿Tienes una laptop o computadora donde puedas trabajar?",
      answers: [
        {
          answer: "💻 Sí",
          distribution_tag_question: [112],
        },
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    6: {
      title: "🎉 ¡Todo listo para tu clase gratis!",
      typeInfo: "congrats",
      subtitle:
        "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
      button: "📅 Agendar clase gratis",
    },
    7: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};